var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('DriverJs',{attrs:{"msg":"Hi! YG...https://juejin.cn/user/501800125607752/posts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }